import request from '@/common/request'

class UsuarioService {
  getAll() {
    return request.get('/usuarios')
  }

  getById(id) {
    return request.get(`/usuarios/${id}`)
  }

  create(data) {
    return request.post('/usuarios', data)
  }

  update(id, data) {
    return request.patch(`/usuarios/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/usuarios/${id}`)
  }
}

export default new UsuarioService()
